module.exports = __webpack_public_path__ + "img/content_info3.1a349320.jpg";